// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022manufacture/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (order: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      order,
      page,
      search,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const addView = () => {
  return http.get(`${urlPrefix}view`);
};

const mainMessage = () => {
  return http.get(`${urlPrefix}main-message`);
};

const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>为贯彻落实全市推动制造业高质量发展大会和《重庆市人民政府办公厅关于印发重庆市推动制造业高质量发展重点专项实施方案的通知》（渝府办发〔2021〕80号）精神，对2021年度推动重庆制造业（含软件服务业，下同）高质量发展的优秀企业家及高级经营管理人才进行激励，在全社会营造尊重企业、尊重企业家、尊重人才的浓厚氛围，树立标杆、塑造典型，在全社会形成良好风尚，向全球展示重庆智造新成果。</p>`,
    2: `<h4>一、指导单位</h4>
<p>中共重庆市委宣传部、重庆市经济和信息化委员会</p>
<h4>二、主办单位</h4>
<p>重庆日报报业集团</p>
<h4>三、协办单位</h4>
<p>重庆市渝北区人民政府</p>
<h4>四、承办单位</h4>
<p>上游新闻</p>`,
    3: `<p>表彰对象为个人，主要面向制造业领域（含软件信息服务业）优秀企业家及高级经营管理人才，重点聚焦重庆市重点培育领军企业（含“链主”企业）、“双百企业”、“专精特新”中小企业以及国家专精特新“小巨人”企业、单项冠军企业等主要经营负责人、高级经营管理人才以及具有突出贡献的创新人才等。</p>
<p>&nbsp;&nbsp;一、坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>&nbsp;&nbsp;二、遵守宪法和法律。</p>
<p>&nbsp;&nbsp;三、具有良好的职业道德、诚实守信、爱岗敬业、学风严谨、为人正派，在制造业（行业）具有良好声誉，近三年没有违法违规行为。</p>
<p>&nbsp;&nbsp;四、在上年度对推动重庆制造业高质量发展做出较大贡献，形成较大社会影响力：</p>
<p>（一）经济表现强劲。参评人经营企业在行业细分领域拥有领先市场地位，上规模、增效益、带动上下游企业发展等方面有亮点做法，拥有较好经济表现。</p>
<p>（二）推动创新发展。参评人所带领企业拥有较强创新能力，在自主研发或推广运用新技术、新产品、新工艺等方面取得较好成效。</p>
<p>（三）培养优秀人才。参评人重视引进和培养人才，在创新人才培养、年青人才培育、改革薪酬激励机制等方面有创新性措施，激发了人才队伍干事创业热情。</p>
<p>（四）具有公众影响。参评人具有公众影响力、知名度、诚信度，积极关注并支持社会公益事业建设。</p>`,
    4: `<p>一、宣传发动。中共重庆市委宣传部、重庆市经济和信息化委员指导推进评选工作，重庆日报报业集团上游新闻以报刊、网络等形式广泛宣传评选活动。</p>
<p>二、组织申报。动员广大参评对象积极参与，接收、汇总、整理参评对象申报材料，对申报材料进行合规性初审。</p>
<p>三、政审考察。书面征求市市场监督管理局、市公安局、市税务局、市检察院、市生态环保局等相关部门意见，对报名参评人员进行政治资格审查，确定实地走访环节参评入围人选。</p>
<p>四、实地走访。采取实地走访等形式对参评人员申报材料真实性、合规性等进行核查，确定网络投票环节入围人选。</p>
<p>五、网络投票。互联网公开展示入围人选基本情况，面向全社会开展投票活动。</p>
<p>六、综合评审。专家评审委员会对入围人选进行综合评价，产生获奖人选建议名单，并报组委会审议。</p>
<p>七、对外公示。组委会审议通过获奖建议名单，由主流媒体向社会进行公示。</p>
<p>八、审定名单。经公示无异议后，组委会最终审定获奖名单。</p>
<p>九、表彰宣传。举行颁奖仪式，向获奖者颁发证书和奖杯；各类媒体以电视、广播、网络、报刊等形式集中宣传年度人物先进事迹，营造浓厚氛围。</p>
<p>备注：具体时间以组委会通知为准。</p>`,
    5: `<h4>一、专业部分</h4>
    <p>（一）个人影响。具有较强的领导力，在行业内有较大的影响力和知名度，社会形象正面、积极、良好，社会评价较高。</p>
    <p>（二）行业影响。所在企业在行业细分领域拥有领先市场地位，在行业内有较强影响力，推动绿色发展。</p>
    <p>（三）产业带动。对产业链大部分企业的资源配置和应用具有较强的直接或间接影响力，带动上下游企业发展。</p>
    <p>（四）创新推动。带领企业拥有较强的创新能力，通过自主研发或推广运用新技术、新产品、新工艺等方便取得较好成效。</p>
    <p>（五）社会贡献。带领企业在营收、利润、税收、研发投入强度以及解决就业以及抗疫救灾、慈善公益等方向有较好表现，对社会发展产生显著贡献。</p>
    <p>（六）人才培育。重视引进和培养人才，在创新人才培养、年青人才培育、改革薪酬激励机制等方面有创新性措施，激发了人才队伍干事创业热情。</p>
    <h4>二、其他部分</h4>
    <p>网络投票情况以及所在企业相关荣誉情况。</p>
    `,
    6: `<h4>报名表下载：</h4>
    <p><a download="第一届重庆市制造业十大影响力年度人物报名表" href="https://testimage.cqcb.com/webupload/o_1fvht42p56kh1godovm1kgl153b7.docx">
    第一届重庆市制造业十大影响力年度人物报名表
    </a></p>
    <h4>报名咨询电话：</h4>
    <p>向老师18580346831（微信同号）</p>
    <h4>报名材料上传邮箱：</h4>
    <p>273744664@qq.com</p>`,
  };
  return data[id];
};
export { getBaseInfo, getVoteList, getDetail, getRules, addView, mainMessage };
